import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  Empty276q86o7r56ey as Empty,
  RemoteFileu6zpetu3ge6n as RemoteFile,
  Empty_instance19pnqi35t6rfs as Empty_instance,
} from '../../components/files/attachmentFilePreview.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { requestFile18ia1vr614wjr as requestFile } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { awaitNotNullzd1xp1uu2voc as awaitNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  Contractor1wog4uk4l8u77 as Contractor,
  Trade15v4llu79udze as Trade,
  License2dabzwgw7jcr2 as License,
  ContractorDocument2jcw9hqg98amj as ContractorDocument,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  conditionyulnlu9fimag as condition,
  eq1298m2cje971u as eq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get__id1te557a8ur54q as get__id } from '../../../../../../crowpay-shared/com/crowpay/TradeFields.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  get_entries3b27rdd1an53 as get_entries,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_contractor3k6krm423825t as get_contractor } from '../../../../../../crowpay-shared/com/crowpay/LicenseFields.mjs';
import { get_contractor2z751sq639xj0 as get_contractor_0 } from '../../../../../../crowpay-shared/com/crowpay/ContractorDocumentFields.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  title1ahgushtajx2d as title_0,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../theming/Titles.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { label287uhiq3m9m4z as label2 } from '../../components/label2.mjs';
import {
  PhoneNumberFormat_USA_getInstance22618h2la6wkm as PhoneNumberFormat_USA_getInstance,
  PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_edit2tiiawv2658bs as get_edit } from '../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_name166ebenv7vstz as get_name,
  get_email2a1pybafs9t2d as get_email,
  get_phoneNumber25jme78ksq49l as get_phoneNumber,
  get_addressidmncntp3o5q as get_address,
  get_contactFirstName4zsaw4v0liuh as get_contactFirstName,
  get_contactLastNamehzwltosy6qkq as get_contactLastName,
  get_contactEmail1hq0is5lnk4tx as get_contactEmail,
  get_contactPhoneNumberlh8nl8hy5d06 as get_contactPhoneNumber,
  get_contactAddress3g7cmdnh6wwi4 as get_contactAddress,
} from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
  assert3pektuc8qw5gc as assert,
  assertNotNull37l8a72xnu5i6 as assertNotNull,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  assertValidEmail3vrj63qp73iex as assertValidEmail,
  assertValidPhoneNumber18rbry4lwjr66 as assertValidPhoneNumber,
} from '../../../utils/validation.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import { validatedmmpm5lnzq3lm as validated_0 } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { withSpacing5keoy85vrpk as withSpacing } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { renderFilePreview3fl8uuiu4tdzl as renderFilePreview } from '../../components/files/renderFiles.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { h417senrl5p41re as h4 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_contactFullName2cmbc6sr57lj as get_contactFullName } from '../../../../../../crowpay-shared/com/crowpay/extensions/Contractor.ext.shared.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  validates376qnagkfv6he as validates,
  issueText2dqtp9rg036jt as issueText,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { space2ppi73m2qk1br as space } from '../../components/space.mjs';
import { renderLicenses2e5bww0s916bf as renderLicenses } from '../../components/files/contractorLicences.mjs';
import { renderContractorDocuments200vd6dka4jio as renderContractorDocuments } from '../../components/files/contractorDocuments.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.ljh_1.gah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'kotlin.also' call
  var this_0 = new (LocalFile())($this.njh_1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp = await_0(this_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = this_0.wgb(LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().mff_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.mjh_1.gah(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.ojh_1 = p0;
      }
      sao($completion) {
        return this.ojh_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ContractorLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = requestFile($this.pjh_1.pc(), listOf('image/*'), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    launch($this.pjh_1, VOID, VOID, ContractorProfile$renderMainContent$slambda$slambda_0($this.qjh_1, tmp0_safe_receiver));
  }
  return Unit_instance;
}
var ContractorProfile$renderMainContent$slambda$slambdaClass;
function ContractorProfile$renderMainContent$slambda$slambda() {
  if (ContractorProfile$renderMainContent$slambda$slambdaClass === VOID) {
    class $ {
      constructor($value, $it) {
        this.mjh_1 = $value;
        this.njh_1 = $it;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorProfile$renderMainContent$slambda$slambdaClass = $;
  }
  return ContractorProfile$renderMainContent$slambda$slambdaClass;
}
function ContractorProfile$renderMainContent$slambda$slambda_0($value, $it) {
  var i = new (ContractorProfile$renderMainContent$slambda$slambda())($value, $it);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.rjh_1.gah(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.sjh_1.xjh_1.f52();
  $this.sjh_1.wjh_1.lai();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = awaitOnce($this.yjh_1.xjh_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  if (image instanceof LocalFile()) {
    var tmp_0 = await_0(image.vgb(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = awaitNotNull(tmp_0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    if (tmp_1) {
      var tmp_2 = modify($this.yjh_1.wjh_1, ContractorProfile$renderMainContent$slambda$slambda_2(image), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    }
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_3 = await_0(this_0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp$ret$0 = tmp_3;
  var tmp_4 = pushChanges($this.yjh_1.wjh_1, tmp$ret$0.jfv_1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = $this.zjh_1.gah(false, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
var ContractorProfile$renderMainContent$slambda$slambdaClass_0;
function ContractorProfile$renderMainContent$slambda$slambda_1() {
  if (ContractorProfile$renderMainContent$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($image) {
        this.aji_1 = $image;
      }
      qip(it, $completion) {
        var tmp = this.aji_1.kgb_1;
        return it.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, ensureNotNull(tmp == null ? null : new (ServerFile())(tmp)).n2n_1);
      }
      s2(p1, $completion) {
        return this.qip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorProfile$renderMainContent$slambda$slambdaClass_0 = $;
  }
  return ContractorProfile$renderMainContent$slambda$slambdaClass_0;
}
function ContractorProfile$renderMainContent$slambda$slambda_2($image) {
  var i = new (ContractorProfile$renderMainContent$slambda$slambda_1())($image);
  var l = (it, $completion) => i.qip(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.bji_1.gah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.cji_1.gah(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.dji_1.vjh_1.lai();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.eji_1.vjh_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    var tmp_0 = $this.fji_1.gah(true, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return Unit_instance;
  }
  var tmp_1 = $this.fji_1.gah(false, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$2 = tmp_2;
  var tmp_3 = pushChanges($this.eji_1.vjh_1, tmp$ret$2.jfv_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = $this.gji_1.gah(false, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function ContractorProfile$contactDraft$lambda($this$Draft) {
  return ensureNotNull($this$Draft.baj($this$Draft.baj(get_session()).jfv_1.eeo($this$Draft.baj(get_notNullContractor()))));
}
function ContractorProfile$companyDraft$lambda($this$Draft) {
  return ensureNotNull($this$Draft.baj($this$Draft.baj(get_session()).jfv_1.eeo($this$Draft.baj(get_notNullContractor()))));
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return () => p0.i2i();
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return (_this__u8e3s4) => {
    p0.oda(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ContractorProfile$renderMainContent$slambdaClass;
function ContractorProfile$renderMainContent$slambda() {
  if (ContractorProfile$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor($editingContractor) {
        this.ljh_1 = $editingContractor;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass;
}
function ContractorProfile$renderMainContent$slambda_0($editingContractor) {
  var i = new (ContractorProfile$renderMainContent$slambda())($editingContractor);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ContractorProfile$renderMainContent$lambda($this$remember) {
  var tmp = $this$remember.baj(get_session()).vfv_1;
  var tmp_0 = condition(true);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Trade()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$0);
  this_0.m4a(get__id(it));
  var tmp$ret$5 = this_0.o1r();
  // Inline function 'kotlin.collections.map' call
  var this_1 = $this$remember.baj(tmp.feo(new (Query())(tmp_0, tmp$ret$5)));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$6 = item.e86_1;
    destination.v(tmp$ret$6);
  }
  return destination;
}
function ContractorProfile$renderMainContent$lambda_0(it) {
  return !(it instanceof Empty());
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ContractorProfile$renderMainContent$slambdaClass_0;
function ContractorProfile$renderMainContent$slambda_1() {
  if (ContractorProfile$renderMainContent$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $value) {
        this.pjh_1 = $$this$button;
        this.qjh_1 = $value;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass_0 = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass_0;
}
function ContractorProfile$renderMainContent$slambda_2($$this$button, $value) {
  var i = new (ContractorProfile$renderMainContent$slambda_1())($$this$button, $value);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ContractorProfile$renderMainContent$lambda$lambda(it) {
  return it.d5j_1;
}
function ContractorProfile$renderMainContent$lambda$lambda_0(og, it) {
  return og.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function ContractorProfile$renderMainContent$lambda$lambda_1($this$remember) {
  return get_entries();
}
function ContractorProfile$renderMainContent$lambda$lambda_2(it) {
  return it.toString();
}
function ContractorProfile$renderMainContent$lambda_1(it) {
  return it.e5j_1;
}
function ContractorProfile$renderMainContent$lambda_2(og, it) {
  return og.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function ContractorProfile$renderMainContent$lambda_3(it) {
  return it == null ? 'Select a Trade' : it;
}
function ContractorProfile$renderMainContent$lambda_4(it) {
  return it.q5j_1;
}
function ContractorProfile$renderMainContent$lambda_5(og, it) {
  return og.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function ContractorProfile$renderMainContent$lambda_6(it) {
  return it.r5j_1;
}
function ContractorProfile$renderMainContent$lambda_7(og, it) {
  return og.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
var ContractorProfile$renderMainContent$slambdaClass_1;
function ContractorProfile$renderMainContent$slambda_3() {
  if (ContractorProfile$renderMainContent$slambdaClass_1 === VOID) {
    class $ {
      constructor($editingContractor, this$0) {
        this.rjh_1 = $editingContractor;
        this.sjh_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass_1 = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass_1;
}
function ContractorProfile$renderMainContent$slambda_4($editingContractor, this$0) {
  var i = new (ContractorProfile$renderMainContent$slambda_3())($editingContractor, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var ContractorProfile$renderMainContent$slambdaClass_2;
function ContractorProfile$renderMainContent$slambda_5() {
  if (ContractorProfile$renderMainContent$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $editingContractor) {
        this.yjh_1 = this$0;
        this.zjh_1 = $editingContractor;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass_2 = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass_2;
}
function ContractorProfile$renderMainContent$slambda_6(this$0, $editingContractor) {
  var i = new (ContractorProfile$renderMainContent$slambda_5())(this$0, $editingContractor);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ContractorProfile$renderMainContent$lambda_8($this$title) {
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_8($this$title);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_8($this$title));
  reactiveScope($this$title, ($this$reactiveScope) => {
    var tmp$ret$0 = 'Contact Information';
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_10(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_10(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_11(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_11(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_12(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_12(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ContractorProfile$renderMainContent$slambdaClass_3;
function ContractorProfile$renderMainContent$slambda_7() {
  if (ContractorProfile$renderMainContent$slambdaClass_3 === VOID) {
    class $ {
      constructor($editingContact) {
        this.bji_1 = $editingContact;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass_3 = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass_3;
}
function ContractorProfile$renderMainContent$slambda_8($editingContact) {
  var i = new (ContractorProfile$renderMainContent$slambda_7())($editingContact);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ContractorProfile$renderMainContent$slambdaClass_4;
function ContractorProfile$renderMainContent$slambda_9() {
  if (ContractorProfile$renderMainContent$slambdaClass_4 === VOID) {
    class $ {
      constructor($editingContact, this$0) {
        this.cji_1 = $editingContact;
        this.dji_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass_4 = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass_4;
}
function ContractorProfile$renderMainContent$slambda_10($editingContact, this$0) {
  var i = new (ContractorProfile$renderMainContent$slambda_9())($editingContact, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ContractorProfile$renderMainContent$slambdaClass_5;
function ContractorProfile$renderMainContent$slambda_11() {
  if (ContractorProfile$renderMainContent$slambdaClass_5 === VOID) {
    class $ {
      constructor(this$0, $saveAttempted, $editingContact) {
        this.eji_1 = this$0;
        this.fji_1 = $saveAttempted;
        this.gji_1 = $editingContact;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorProfile$renderMainContent$slambdaClass_5 = $;
  }
  return ContractorProfile$renderMainContent$slambdaClass_5;
}
function ContractorProfile$renderMainContent$slambda_12(this$0, $saveAttempted, $editingContact) {
  var i = new (ContractorProfile$renderMainContent$slambda_11())(this$0, $saveAttempted, $editingContact);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ContractorProfile$renderMainContent$lambda_9($this$remember) {
  var tmp = $this$remember.baj(get_session()).lfv_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp$ret$4 = eq(get_contractor(it), $this$remember.baj(get_notNullContractor()));
  return $this$remember.baj(tmp.feo(new (Query())(tmp$ret$4)));
}
function ContractorProfile$renderMainContent$lambda_10($this$remember) {
  var tmp = $this$remember.baj(get_session()).kfv_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(ContractorDocument()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp$ret$4 = eq(get_contractor_0(it), $this$remember.baj(get_notNullContractor()));
  return $this$remember.faj(tmp.feo(new (Query())(tmp$ret$4)));
}
var ContractorProfileClass;
function ContractorProfile() {
  if (ContractorProfileClass === VOID) {
    class $ {
      constructor() {
        this.tjh_1 = new (Constant())(_Constant___init__impl__v45mub('Profile'));
        this.ujh_1 = MemberRole_Manager_getInstance();
        var tmp = this;
        tmp.vjh_1 = validated(Draft(ContractorProfile$contactDraft$lambda));
        var tmp_0 = this;
        tmp_0.wjh_1 = validated(Draft(ContractorProfile$companyDraft$lambda));
        var tmp_1 = this;
        tmp_1.xjh_1 = MutableRemember().rak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
          var tmp0_safe_receiver = $this$MutableRemember.baj(this.wjh_1).c5j_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
            tmp = null;
          } else {
            var tmp_1 = tmp0_safe_receiver;
            // Inline function 'kotlin.let' call
            var it = (tmp_1 == null ? null : new (ServerFile())(tmp_1)).n2n_1;
            tmp = new (RemoteFile())(_ServerFile___get_location__impl__ddyqaq(it));
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? Empty_instance : tmp1_elvis_lhs;
        });
      }
      ucv() {
        return this.tjh_1;
      }
      bhg() {
        return this.ujh_1;
      }
      rhi(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        view.zb8(get_dp(0));
        title(view, 'Profile');
        var tmp_0 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), get_padded(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().yg1_1);
        view_0.zb8(get_AppDimensions().yg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().gg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowCollapsingToColumn())(view_0.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        var tmp_1 = view_1.ibb(get_section(view_1), get_expanding(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.eba(get_AppDimensions().xg1_1);
        view_2.zb8(get_AppDimensions().xg1_1);
        var editingContractor = Signal().fak(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(true);
        title_0(view_3, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.baj(this.wjh_1.yaj()).d5j_1.a4_1 + ' Information';
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        });
        var tmp_2 = shownWhen(view_3, VOID, ($this$shownWhen) => !$this$shownWhen.baj(editingContractor));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        view_5.xbm(true);
        label2(view_5, 'Name', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$2 = $this$reactiveScope.baj(this.wjh_1.yaj()).x5i_1;
            this_0.set(tmp$ret$2);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_5, 'Email', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_1(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$9 = $this$reactiveScope.baj(this.wjh_1.yaj()).z5i_1;
            this_0.set(tmp$ret$9);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_5, 'Phone Number', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_2(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_2(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp = PhoneNumberFormat_USA_getInstance();
            // Inline function 'kotlin.text.filter' call
            var tmp0 = $this$reactiveScope.baj(this.wjh_1.yaj()).a5j_1;
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (isDigit(element)) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var tmp$ret$18 = destination.toString();
            var tmp$ret$19 = tmp.yda(tmp$ret$18);
            this_0.set(tmp$ret$19);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_5, 'Address', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_3(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_3(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$26 = $this$reactiveScope.baj(this.wjh_1.yaj()).b5j_1.toString();
            this_0.set(tmp$ret$26);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_5, 'Logo', VOID, ($this$label2) => {
          var tmp = sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, get_rem(5), get_rem(5));
          // Inline function 'com.lightningkite.kiteui.views.direct.image' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (ImageView())($this$label2);
          this_0.pda(ImageScaleType_Fit_getInstance());
          this_0.ebu('Logo');
          var tmp_0 = KMutableProperty0();
          var tmp_1 = ImageView$_get_source_$ref_ain7z1(this_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('source', 0, tmp_0, tmp_1, ImageView$_set_source_$ref_4jld67(this_0));
          reactiveScope($this$label2, ($this$reactiveScope) => {
            var tmp$ret$33 = $this$reactiveScope.baj(this.xjh_1).tgb();
            this_1.set(tmp$ret$33);
            return Unit_instance;
          });
          this_0.zba();
          return $this$label2.jbb(tmp, this_0);
        });
        label2(view_5, 'Preferred Title', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_4(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_4(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$39 = $this$reactiveScope.baj(this.wjh_1.yaj()).d5j_1.toString();
            this_0.set(tmp$ret$39);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_5, 'Trade', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_5(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_5(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp0_elvis_lhs = $this$reactiveScope.baj(this.wjh_1.yaj()).e5j_1;
            var tmp$ret$46 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            this_0.set(tmp$ret$46);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Space())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_5.fbb(p_6, view_6);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Other Legal Information';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextView())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.ebb(p_7, view_7);
        view_7.jba(view_7.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_3 = view_7.tb5_1;
        var tmp_4;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_4 = '\xA0';
        } else {
          tmp_4 = content;
        }
        tmp_3.fbu(tmp_4);
        view_5.fbb(p_7, view_7);
        label2(view_5, 'State Entity Number', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_6(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_6(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$62 = $this$reactiveScope.baj(this.wjh_1.yaj()).q5j_1;
            this_0.set(tmp$ret$62);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_5, 'EIN/Social/Tax ID', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_7(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_7(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$69 = $this$reactiveScope.baj(this.wjh_1.yaj()).r5j_1;
            this_0.set(tmp$ret$69);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        align(view_5, Align_End_getInstance(), Align_Center_getInstance());
        var tmp_5 = get_tertiaryButton(view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_8 = view_5.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
        view_5.ebb(p_8, view_8);
        icon(view_8, get_edit(Companion_getInstance()), 'Edit Business Information');
        onClick(view_8, VOID, VOID, ContractorProfile$renderMainContent$slambda_0(editingContractor));
        view_5.fbb(p_8, view_8);
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.contains' call
        view_5.jbb(tmp_5, view_8);
        view_4.fbb(p_5, view_5);
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_2, view_4);
        var tmp_6 = shownWhen(view_3, VOID, ($this$shownWhen) => $this$shownWhen.baj(editingContractor));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_9 = view_3.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_3 : tmp0_elvis_lhs_9;
        view_3.ebb(p_9, view_9);
        view_9.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view_9.pc());
        var tmp0_elvis_lhs_10 = view_9.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
        view_9.ebb(p_10, view_10);
        view_10.xbm(true);
        var availableTrades = remember(VOID, VOID, VOID, ContractorProfile$renderMainContent$lambda);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_11 = view_10.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
        view_10.ebb(p_11, view_11);
        view_11.xbm(true);
        view_11.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.ebb(p_12, view_12);
        view_12.xbm(false);
        view_12.zb8(get_AppDimensions().pg2_1);
        view_12.jbb(get_centered(view_12), bodyBold(view_12, 'Name'));
        view_12.jbb(colored(view_12, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_12, '*'));
        view_11.fbb(p_12, view_12);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_7 = view_11.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.wjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_8 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$93 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$93);
        var tmp$ret$95 = get_name(it);
        var tmp$ret$96 = lensPath(this_0, tmp$ret$95);
        var value = assertNotBlank(tmp$ret$96);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (TextInput())(view_11.pc());
        var tmp0_elvis_lhs_13 = view_11.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
        view_11.ebb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_13.tb5_1.zb3_1.ib7_1.placeholder = 'Name';
        view_13.xah(view_13.gcn_1, value);
        view_11.fbb(p_13, view_13);
        view_11.jbb(tmp_7, view_13);
        view_10.fbb(p_11, view_11);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_14 = view_10.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_10 : tmp0_elvis_lhs_14;
        view_10.ebb(p_14, view_14);
        view_14.xbm(true);
        view_14.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_14.pc());
        var tmp0_elvis_lhs_15 = view_14.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
        view_14.ebb(p_15, view_15);
        view_15.xbm(false);
        view_15.zb8(get_AppDimensions().pg2_1);
        view_15.jbb(get_centered(view_15), bodyBold(view_15, 'Email'));
        view_15.jbb(colored(view_15, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_15, '*'));
        view_14.fbb(p_15, view_15);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_9 = view_14.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.wjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_10 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$113 = isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$113);
        var tmp$ret$115 = get_email(it_0);
        var tmp$ret$116 = lensPath(this_1, tmp$ret$115);
        var value_0 = assertValidEmail(tmp$ret$116);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (TextInput())(view_14.pc());
        var tmp0_elvis_lhs_16 = view_14.cbb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
        view_14.ebb(p_16, view_16);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_16.tb5_1.zb3_1.ib7_1.placeholder = 'Email';
        view_16.xah(view_16.gcn_1, value_0);
        view_14.fbb(p_16, view_16);
        view_14.jbb(tmp_9, view_16);
        view_10.fbb(p_14, view_14);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Phone Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_17 = view_10.cbb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_10 : tmp0_elvis_lhs_17;
        view_10.ebb(p_17, view_17);
        view_17.xbm(true);
        view_17.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_18 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_18 = view_17.cbb_1;
        var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
        view_17.ebb(p_18, view_18);
        view_18.xbm(false);
        view_18.zb8(get_AppDimensions().pg2_1);
        view_18.jbb(get_centered(view_18), bodyBold(view_18, label));
        view_18.jbb(colored(view_18, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_18, '*'));
        view_17.fbb(p_18, view_18);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_11 = view_17.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.wjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_12 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$133 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$133);
        var tmp$ret$135 = get_phoneNumber(it_1);
        var tmp$ret$136 = lensPath(this_2, tmp$ret$135);
        var value_1 = assertValidPhoneNumber(tmp$ret$136);
        // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
        // Inline function 'kotlin.apply' call
        var this_3 = new (PhoneNumberInput())(view_17);
        this_3.tcl('Phone Number');
        view_17.xah(this_3.e2a(), value_1);
        view_17.jbb(tmp_11, this_3);
        view_10.fbb(p_17, view_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (Space())(view_10.pc());
        var tmp0_elvis_lhs_19 = view_10.cbb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view_10 : tmp0_elvis_lhs_19;
        view_10.ebb(p_19, view_19);
        view_10.fbb(p_19, view_19);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (TextView())(view_10.pc());
        var tmp0_elvis_lhs_20 = view_10.cbb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_10 : tmp0_elvis_lhs_20;
        view_10.ebb(p_20, view_20);
        view_20.jba(view_20.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_13 = view_20.tb5_1;
        var tmp_14;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Address') === 0) {
          tmp_14 = '\xA0';
        } else {
          tmp_14 = 'Address';
        }
        tmp_13.fbu(tmp_14);
        view_10.fbb(p_20, view_20);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_4 = this.wjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_15 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$155 = isInterface(tmp_15, KSerializer()) ? tmp_15 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$155);
        var tmp$ret$157 = get_address(it_2);
        var tmp$ret$158 = lensPath(this_4, tmp$ret$157);
        addressForm(view_10, tmp$ret$158);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_21 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_21 = view_10.cbb_1;
        var p_21 = tmp0_elvis_lhs_21 == null ? view_10 : tmp0_elvis_lhs_21;
        view_10.ebb(p_21, view_21);
        view_21.xbm(true);
        view_21.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_22 = new (RowOrCol())(view_21.pc());
        var tmp0_elvis_lhs_22 = view_21.cbb_1;
        var p_22 = tmp0_elvis_lhs_22 == null ? view_21 : tmp0_elvis_lhs_22;
        view_21.ebb(p_22, view_22);
        view_22.xbm(false);
        view_22.zb8(get_AppDimensions().pg2_1);
        view_22.jbb(get_centered(view_22), bodyBold(view_22, 'Logo'));
        view_22.jbb(colored(view_22, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_22, '*'));
        view_21.fbb(p_22, view_22);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_16 = view_21.hbb(FieldSemantic_getInstance());
        var tmp_17 = validated_0(this.xjh_1, this.wjh_1.vat());
        var value_2 = assert(tmp_17, 'Must provide an image', VOID, VOID, ContractorProfile$renderMainContent$lambda_0);
        var tmp_18 = view_21.ibb(sizeConstraints(view_21, VOID, VOID, VOID, VOID, VOID, get_rem(6), get_rem(6)), withSpacing(view_21, 0.0));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_23 = new (Button())(view_21.pc());
        var tmp0_elvis_lhs_23 = view_21.cbb_1;
        var p_23 = tmp0_elvis_lhs_23 == null ? view_21 : tmp0_elvis_lhs_23;
        view_21.ebb(p_23, view_23);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_24 = new (Frame())(view_23.pc());
        var tmp0_elvis_lhs_24 = view_23.cbb_1;
        var p_24 = tmp0_elvis_lhs_24 == null ? view_23 : tmp0_elvis_lhs_24;
        view_23.ebb(p_24, view_24);
        var $this$frame = view_24;
        reactiveScope($this$frame, ($this$reactiveScope) => {
          $this$frame.zb9();
          var filePreview = $this$reactiveScope.baj(value_2);
          renderFilePreview($this$frame, filePreview, get_rem(6));
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = $this$frame;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())(this_0.pc());
          var tmp0_elvis_lhs = this_0.cbb_1;
          var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
          this_0.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_shown_$ref_kipsub(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('shown', 0, tmp, tmp_0, TextView$_set_shown_$ref_l7jsq9(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$164 = equals($this$reactiveScope.baj(value_2), Empty_instance);
            this_1.set(tmp$ret$164);
            return Unit_instance;
          });
          view.bbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Image\nUpload';
          var tmp_1 = view.tb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = value;
          }
          tmp_1.fbu(tmp_2);
          this_0.fbb(p, view);
          return Unit_instance;
        });
        view_23.fbb(p_24, view_24);
        onClick(view_23, VOID, VOID, ContractorProfile$renderMainContent$slambda_2(view_23, value_2));
        view_21.fbb(p_23, view_23);
        var tmp$ret$179 = view_21.jbb(tmp_18, view_23);
        view_21.jbb(tmp_16, tmp$ret$179);
        view_10.fbb(p_21, view_21);
        label2(view_10, 'Preferred Title', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.hbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          var tmp_0 = ContractorProfile$renderMainContent$lambda$lambda;
          var tmp_1 = this.wjh_1.bak(tmp_0, ContractorProfile$renderMainContent$lambda$lambda_0);
          var tmp_2 = remember(VOID, VOID, VOID, ContractorProfile$renderMainContent$lambda$lambda_1);
          view.mcf(tmp_1, tmp_2, ContractorProfile$renderMainContent$lambda$lambda_2);
          $this$label2.fbb(p, view);
          return $this$label2.jbb(tmp, view);
        });
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_25 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_25 = view_10.cbb_1;
        var p_25 = tmp0_elvis_lhs_25 == null ? view_10 : tmp0_elvis_lhs_25;
        view_10.ebb(p_25, view_25);
        view_25.xbm(true);
        view_25.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_26 = new (RowOrCol())(view_25.pc());
        var tmp0_elvis_lhs_26 = view_25.cbb_1;
        var p_26 = tmp0_elvis_lhs_26 == null ? view_25 : tmp0_elvis_lhs_26;
        view_25.ebb(p_26, view_26);
        view_26.xbm(false);
        view_26.zb8(get_AppDimensions().pg2_1);
        view_26.jbb(get_centered(view_26), bodyBold(view_26, 'Trade'));
        view_26.jbb(colored(view_26, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_26, '*'));
        view_25.fbb(p_26, view_26);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_19 = view_25.hbb(FieldSemantic_getInstance());
        var tmp_20 = ContractorProfile$renderMainContent$lambda_1;
        var value_3 = assertNotNull(this.wjh_1.bak(tmp_20, ContractorProfile$renderMainContent$lambda_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_27 = new (Select())(view_25.pc());
        var tmp0_elvis_lhs_27 = view_25.cbb_1;
        var p_27 = tmp0_elvis_lhs_27 == null ? view_25 : tmp0_elvis_lhs_27;
        view_25.ebb(p_27, view_27);
        var tmp_21 = remember(VOID, VOID, VOID, ($this$remember) => plus(listOf(null), $this$remember.baj(availableTrades)));
        view_27.mcf(value_3, tmp_21, ContractorProfile$renderMainContent$lambda_3);
        view_25.fbb(p_27, view_27);
        view_25.jbb(tmp_19, view_27);
        view_10.fbb(p_25, view_25);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_28 = new (Space())(view_10.pc());
        var tmp0_elvis_lhs_28 = view_10.cbb_1;
        var p_28 = tmp0_elvis_lhs_28 == null ? view_10 : tmp0_elvis_lhs_28;
        view_10.ebb(p_28, view_28);
        view_10.fbb(p_28, view_28);
        h4(view_10, 'Other Legal Information');
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_0 = 'State Entity Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_29 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_29 = view_10.cbb_1;
        var p_29 = tmp0_elvis_lhs_29 == null ? view_10 : tmp0_elvis_lhs_29;
        view_10.ebb(p_29, view_29);
        view_29.xbm(true);
        view_29.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_30 = new (RowOrCol())(view_29.pc());
        var tmp0_elvis_lhs_30 = view_29.cbb_1;
        var p_30 = tmp0_elvis_lhs_30 == null ? view_29 : tmp0_elvis_lhs_30;
        view_29.ebb(p_30, view_30);
        view_30.xbm(false);
        view_30.zb8(get_AppDimensions().pg2_1);
        view_30.jbb(get_centered(view_30), bodyBold(view_30, label_0));
        view_30.jbb(colored(view_30, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_30, '*'));
        view_29.fbb(p_30, view_30);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_22 = view_29.hbb(FieldSemantic_getInstance());
        var tmp_23 = ContractorProfile$renderMainContent$lambda_4;
        var value_4 = assertNotBlank(this.wjh_1.bak(tmp_23, ContractorProfile$renderMainContent$lambda_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_31 = new (TextInput())(view_29.pc());
        var tmp0_elvis_lhs_31 = view_29.cbb_1;
        var p_31 = tmp0_elvis_lhs_31 == null ? view_29 : tmp0_elvis_lhs_31;
        view_29.ebb(p_31, view_31);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_5 = 'State Entity Number';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_31.tb5_1.zb3_1.ib7_1.placeholder = value_5;
        view_31.xah(view_31.gcn_1, value_4);
        view_29.fbb(p_31, view_31);
        view_29.jbb(tmp_22, view_31);
        view_10.fbb(p_29, view_29);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_1 = 'EIN/Social/Tax ID';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_32 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_32 = view_10.cbb_1;
        var p_32 = tmp0_elvis_lhs_32 == null ? view_10 : tmp0_elvis_lhs_32;
        view_10.ebb(p_32, view_32);
        view_32.xbm(true);
        view_32.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_33 = new (RowOrCol())(view_32.pc());
        var tmp0_elvis_lhs_33 = view_32.cbb_1;
        var p_33 = tmp0_elvis_lhs_33 == null ? view_32 : tmp0_elvis_lhs_33;
        view_32.ebb(p_33, view_33);
        view_33.xbm(false);
        view_33.zb8(get_AppDimensions().pg2_1);
        view_33.jbb(get_centered(view_33), bodyBold(view_33, label_1));
        view_33.jbb(colored(view_33, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_33, '*'));
        view_32.fbb(p_33, view_33);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_24 = view_32.hbb(FieldSemantic_getInstance());
        var tmp_25 = ContractorProfile$renderMainContent$lambda_6;
        var value_6 = assertNotBlank(this.wjh_1.bak(tmp_25, ContractorProfile$renderMainContent$lambda_7));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_34 = new (TextInput())(view_32.pc());
        var tmp0_elvis_lhs_34 = view_32.cbb_1;
        var p_34 = tmp0_elvis_lhs_34 == null ? view_32 : tmp0_elvis_lhs_34;
        view_32.ebb(p_34, view_34);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_7 = 'EIN/Social/Tax IDr';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_34.tb5_1.zb3_1.ib7_1.placeholder = value_7;
        view_34.xah(view_34.gcn_1, value_6);
        view_32.fbb(p_34, view_34);
        view_32.jbb(tmp_24, view_34);
        view_10.fbb(p_32, view_32);
        var tmp_26 = align(view_10, Align_End_getInstance(), Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_35 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_35 = view_10.cbb_1;
        var p_35 = tmp0_elvis_lhs_35 == null ? view_10 : tmp0_elvis_lhs_35;
        view_10.ebb(p_35, view_35);
        view_35.xbm(false);
        view_35.zb8(get_AppDimensions().ig2_1);
        var tmp_27 = get_textButton(view_35);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_36 = new (Button())(view_35.pc());
        var tmp0_elvis_lhs_36 = view_35.cbb_1;
        var p_36 = tmp0_elvis_lhs_36 == null ? view_35 : tmp0_elvis_lhs_36;
        view_35.ebb(p_36, view_36);
        specCenteredText(view_36, 'Cancel');
        onClick(view_36, VOID, VOID, ContractorProfile$renderMainContent$slambda_4(editingContractor, this));
        view_35.fbb(p_36, view_36);
        view_35.jbb(tmp_27, view_36);
        var tmp_28 = get_tertiaryButton(view_35);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_37 = new (Button())(view_35.pc());
        var tmp0_elvis_lhs_37 = view_35.cbb_1;
        var p_37 = tmp0_elvis_lhs_37 == null ? view_35 : tmp0_elvis_lhs_37;
        view_35.ebb(p_37, view_37);
        var tmp_29 = KMutableProperty0();
        var tmp_30 = Button$_get_enabled_$ref_61t7nx(view_37);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_5 = getPropertyCallableRef('enabled', 0, tmp_29, tmp_30, Button$_set_enabled_$ref_o8kynz(view_37));
        reactiveScope(view_37, ($this$reactiveScope) => {
          var tmp$ret$241 = $this$reactiveScope.baj(get_issues(this.wjh_1)).i1();
          this_5.set(tmp$ret$241);
          return Unit_instance;
        });
        specCenteredText(view_37, 'Save');
        onClick(view_37, VOID, VOID, ContractorProfile$renderMainContent$slambda_6(this, editingContractor));
        view_35.fbb(p_37, view_37);
        view_35.jbb(tmp_28, view_37);
        view_10.fbb(p_35, view_35);
        view_10.jbb(tmp_26, view_35);
        view_9.fbb(p_10, view_10);
        view_3.fbb(p_9, view_9);
        view_3.jbb(tmp_6, view_9);
        view_2.fbb(p_3, view_3);
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_1, view_2);
        var tmp_31 = view_1.ibb(get_section(view_1), get_expanding(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_38 = new (Frame())(view_1.pc());
        var tmp0_elvis_lhs_38 = view_1.cbb_1;
        var p_38 = tmp0_elvis_lhs_38 == null ? view_1 : tmp0_elvis_lhs_38;
        view_1.ebb(p_38, view_38);
        view_38.eba(get_AppDimensions().xg1_1);
        view_38.zb8(get_AppDimensions().xg1_1);
        var editingContact = Signal().fak(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_39 = new (RowOrCol())(view_38.pc());
        var tmp0_elvis_lhs_39 = view_38.cbb_1;
        var p_39 = tmp0_elvis_lhs_39 == null ? view_38 : tmp0_elvis_lhs_39;
        view_38.ebb(p_39, view_39);
        view_39.xbm(true);
        title_0(view_39, ContractorProfile$renderMainContent$lambda_8);
        var tmp_32 = shownWhen(view_39, VOID, ($this$shownWhen) => !$this$shownWhen.baj(editingContact));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_40 = new (RowOrCol())(view_39.pc());
        var tmp0_elvis_lhs_40 = view_39.cbb_1;
        var p_40 = tmp0_elvis_lhs_40 == null ? view_39 : tmp0_elvis_lhs_40;
        view_39.ebb(p_40, view_40);
        view_40.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_41 = new (RowOrCol())(view_40.pc());
        var tmp0_elvis_lhs_41 = view_40.cbb_1;
        var p_41 = tmp0_elvis_lhs_41 == null ? view_40 : tmp0_elvis_lhs_41;
        view_40.ebb(p_41, view_41);
        view_41.xbm(true);
        label2(view_41, 'Name', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_9(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_9(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$265 = get_contactFullName($this$reactiveScope.baj(this.vjh_1));
            this_0.set(tmp$ret$265);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_41, 'Email', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_10(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_10(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$272 = $this$reactiveScope.baj(this.vjh_1).i5j_1;
            this_0.set(tmp$ret$272);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_41, 'Phone Number', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_11(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_11(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$279 = PhoneNumberFormat_USA_getInstance().yda($this$reactiveScope.baj(this.vjh_1).j5j_1);
            this_0.set(tmp$ret$279);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        label2(view_41, 'Address', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_12(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_12(view));
          reactiveScope(view, ($this$reactiveScope) => {
            // Inline function 'kotlin.also' call
            var this_1 = $this$reactiveScope.baj(this.vjh_1).k5j_1.toString();
            println('Address: ' + this_1);
            this_0.set(this_1);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        });
        align(view_41, Align_End_getInstance(), Align_Center_getInstance());
        var tmp_33 = get_tertiaryButton(view_41);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_42 = new (Button())(view_41.pc());
        var tmp0_elvis_lhs_42 = view_41.cbb_1;
        var p_42 = tmp0_elvis_lhs_42 == null ? view_41 : tmp0_elvis_lhs_42;
        view_41.ebb(p_42, view_42);
        icon(view_42, get_edit(Companion_getInstance()), 'Edit Contact Information');
        onClick(view_42, VOID, VOID, ContractorProfile$renderMainContent$slambda_8(editingContact));
        view_41.fbb(p_42, view_42);
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.contains' call
        view_41.jbb(tmp_33, view_42);
        view_40.fbb(p_41, view_41);
        view_39.fbb(p_40, view_40);
        view_39.jbb(tmp_32, view_40);
        var tmp_34 = shownWhen(view_39, VOID, ($this$shownWhen) => $this$shownWhen.baj(editingContact));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_43 = new (RowOrCol())(view_39.pc());
        var tmp0_elvis_lhs_43 = view_39.cbb_1;
        var p_43 = tmp0_elvis_lhs_43 == null ? view_39 : tmp0_elvis_lhs_43;
        view_39.ebb(p_43, view_43);
        view_43.xbm(true);
        var saveAttempted = Signal().fak(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_44 = new (RowOrCol())(view_43.pc());
        var tmp0_elvis_lhs_44 = view_43.cbb_1;
        var p_44 = tmp0_elvis_lhs_44 == null ? view_43 : tmp0_elvis_lhs_44;
        view_43.ebb(p_44, view_44);
        view_44.xbm(true);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_2 = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_45 = new (RowOrCol())(view_44.pc());
        var tmp0_elvis_lhs_45 = view_44.cbb_1;
        var p_45 = tmp0_elvis_lhs_45 == null ? view_44 : tmp0_elvis_lhs_45;
        view_44.ebb(p_45, view_45);
        view_45.xbm(true);
        view_45.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_46 = new (RowOrCol())(view_45.pc());
        var tmp0_elvis_lhs_46 = view_45.cbb_1;
        var p_46 = tmp0_elvis_lhs_46 == null ? view_45 : tmp0_elvis_lhs_46;
        view_45.ebb(p_46, view_46);
        view_46.xbm(false);
        view_46.zb8(get_AppDimensions().pg2_1);
        view_46.jbb(get_centered(view_46), bodyBold(view_46, label_2));
        view_46.jbb(colored(view_46, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_46, '*'));
        view_45.fbb(p_46, view_46);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_35 = view_45.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_6 = this.vjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_36 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$312 = isInterface(tmp_36, KSerializer()) ? tmp_36 : THROW_CCE();
        var it_3 = new (DataClassPathSelf())(tmp$ret$312);
        var tmp$ret$314 = get_contactFirstName(it_3);
        var tmp$ret$315 = lensPath(this_6, tmp$ret$314);
        var value_8 = assertNotBlank(tmp$ret$315, 'First Name cannot be blank');
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_47 = new (TextInput())(view_45.pc());
        var tmp0_elvis_lhs_47 = view_45.cbb_1;
        var p_47 = tmp0_elvis_lhs_47 == null ? view_45 : tmp0_elvis_lhs_47;
        view_45.ebb(p_47, view_47);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_9 = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_47.tb5_1.zb3_1.ib7_1.placeholder = value_9;
        view_47.xah(view_47.gcn_1, value_8);
        validates(view_47, [value_8], ($this$validates) => $this$validates.baj(saveAttempted));
        view_45.fbb(p_47, view_47);
        var tmp_37 = get_issues(value_8);
        var tmp$ret$321 = issueText(view_45, tmp_37, VOID, ($this$issueText) => $this$issueText.baj(saveAttempted));
        view_45.jbb(tmp_35, tmp$ret$321);
        view_44.fbb(p_45, view_45);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_3 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_48 = new (RowOrCol())(view_44.pc());
        var tmp0_elvis_lhs_48 = view_44.cbb_1;
        var p_48 = tmp0_elvis_lhs_48 == null ? view_44 : tmp0_elvis_lhs_48;
        view_44.ebb(p_48, view_48);
        view_48.xbm(true);
        view_48.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_49 = new (RowOrCol())(view_48.pc());
        var tmp0_elvis_lhs_49 = view_48.cbb_1;
        var p_49 = tmp0_elvis_lhs_49 == null ? view_48 : tmp0_elvis_lhs_49;
        view_48.ebb(p_49, view_49);
        view_49.xbm(false);
        view_49.zb8(get_AppDimensions().pg2_1);
        view_49.jbb(get_centered(view_49), bodyBold(view_49, label_3));
        view_49.jbb(colored(view_49, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_49, '*'));
        view_48.fbb(p_49, view_49);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_38 = view_48.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_7 = this.vjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_39 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$332 = isInterface(tmp_39, KSerializer()) ? tmp_39 : THROW_CCE();
        var it_4 = new (DataClassPathSelf())(tmp$ret$332);
        var tmp$ret$334 = get_contactLastName(it_4);
        var tmp$ret$335 = lensPath(this_7, tmp$ret$334);
        var value_10 = assertNotBlank(tmp$ret$335, 'Last Name cannot be blank');
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_50 = new (TextInput())(view_48.pc());
        var tmp0_elvis_lhs_50 = view_48.cbb_1;
        var p_50 = tmp0_elvis_lhs_50 == null ? view_48 : tmp0_elvis_lhs_50;
        view_48.ebb(p_50, view_50);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_11 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_50.tb5_1.zb3_1.ib7_1.placeholder = value_11;
        view_50.xah(view_50.gcn_1, value_10);
        validates(view_50, [value_10], ($this$validates) => $this$validates.baj(saveAttempted));
        view_48.fbb(p_50, view_50);
        var tmp_40 = get_issues(value_10);
        var tmp$ret$341 = issueText(view_48, tmp_40, VOID, ($this$issueText) => $this$issueText.baj(saveAttempted));
        view_48.jbb(tmp_38, tmp$ret$341);
        view_44.fbb(p_48, view_48);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_51 = new (RowOrCol())(view_44.pc());
        var tmp0_elvis_lhs_51 = view_44.cbb_1;
        var p_51 = tmp0_elvis_lhs_51 == null ? view_44 : tmp0_elvis_lhs_51;
        view_44.ebb(p_51, view_51);
        view_51.xbm(true);
        view_51.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_52 = new (RowOrCol())(view_51.pc());
        var tmp0_elvis_lhs_52 = view_51.cbb_1;
        var p_52 = tmp0_elvis_lhs_52 == null ? view_51 : tmp0_elvis_lhs_52;
        view_51.ebb(p_52, view_52);
        view_52.xbm(false);
        view_52.zb8(get_AppDimensions().pg2_1);
        view_52.jbb(get_centered(view_52), bodyBold(view_52, 'Email'));
        view_52.jbb(colored(view_52, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_52, '*'));
        view_51.fbb(p_52, view_52);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_41 = view_51.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_8 = this.vjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_42 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$352 = isInterface(tmp_42, KSerializer()) ? tmp_42 : THROW_CCE();
        var it_5 = new (DataClassPathSelf())(tmp$ret$352);
        var tmp$ret$354 = get_contactEmail(it_5);
        var tmp$ret$355 = lensPath(this_8, tmp$ret$354);
        var value_12 = assertValidEmail(tmp$ret$355);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_53 = new (TextInput())(view_51.pc());
        var tmp0_elvis_lhs_53 = view_51.cbb_1;
        var p_53 = tmp0_elvis_lhs_53 == null ? view_51 : tmp0_elvis_lhs_53;
        view_51.ebb(p_53, view_53);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_53.tb5_1.zb3_1.ib7_1.placeholder = 'Email';
        view_53.xah(view_53.gcn_1, value_12);
        validates(view_53, [value_12], ($this$validates) => $this$validates.baj(saveAttempted));
        view_51.fbb(p_53, view_53);
        var tmp_43 = get_issues(value_12);
        var tmp$ret$361 = issueText(view_51, tmp_43, VOID, ($this$issueText) => $this$issueText.baj(saveAttempted));
        view_51.jbb(tmp_41, tmp$ret$361);
        view_44.fbb(p_51, view_51);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_4 = 'Phone Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_54 = new (RowOrCol())(view_44.pc());
        var tmp0_elvis_lhs_54 = view_44.cbb_1;
        var p_54 = tmp0_elvis_lhs_54 == null ? view_44 : tmp0_elvis_lhs_54;
        view_44.ebb(p_54, view_54);
        view_54.xbm(true);
        view_54.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_55 = new (RowOrCol())(view_54.pc());
        var tmp0_elvis_lhs_55 = view_54.cbb_1;
        var p_55 = tmp0_elvis_lhs_55 == null ? view_54 : tmp0_elvis_lhs_55;
        view_54.ebb(p_55, view_55);
        view_55.xbm(false);
        view_55.zb8(get_AppDimensions().pg2_1);
        view_55.jbb(get_centered(view_55), bodyBold(view_55, label_4));
        view_55.jbb(colored(view_55, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_55, '*'));
        view_54.fbb(p_55, view_55);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_44 = view_54.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_9 = this.vjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_45 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$372 = isInterface(tmp_45, KSerializer()) ? tmp_45 : THROW_CCE();
        var it_6 = new (DataClassPathSelf())(tmp$ret$372);
        var tmp$ret$374 = get_contactPhoneNumber(it_6);
        var tmp$ret$375 = lensPath(this_9, tmp$ret$374);
        var value_13 = assertValidPhoneNumber(tmp$ret$375);
        // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
        // Inline function 'kotlin.apply' call
        var this_10 = new (PhoneNumberInput())(view_54);
        this_10.tcl('Phone Number');
        view_54.xah(this_10.e2a(), value_13);
        var tmp_46 = get_issues(value_13);
        var tmp$ret$379 = issueText(view_54, tmp_46, VOID, ($this$issueText) => $this$issueText.baj(saveAttempted));
        view_54.jbb(tmp_44, tmp$ret$379);
        view_44.fbb(p_54, view_54);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_56 = new (Space())(view_44.pc());
        var tmp0_elvis_lhs_56 = view_44.cbb_1;
        var p_56 = tmp0_elvis_lhs_56 == null ? view_44 : tmp0_elvis_lhs_56;
        view_44.ebb(p_56, view_56);
        view_44.fbb(p_56, view_56);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_57 = new (TextView())(view_44.pc());
        var tmp0_elvis_lhs_57 = view_44.cbb_1;
        var p_57 = tmp0_elvis_lhs_57 == null ? view_44 : tmp0_elvis_lhs_57;
        view_44.ebb(p_57, view_57);
        view_57.jba(view_57.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_47 = view_57.tb5_1;
        var tmp_48;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Address') === 0) {
          tmp_48 = '\xA0';
        } else {
          tmp_48 = 'Address';
        }
        tmp_47.fbu(tmp_48);
        view_44.fbb(p_57, view_57);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_11 = this.vjh_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_49 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$394 = isInterface(tmp_49, KSerializer()) ? tmp_49 : THROW_CCE();
        var it_7 = new (DataClassPathSelf())(tmp$ret$394);
        var tmp$ret$396 = get_contactAddress(it_7);
        var tmp_50 = lensPath(this_11, tmp$ret$396);
        addressForm(view_44, tmp_50, VOID, VOID, VOID, ($this$addressForm) => $this$addressForm.baj(saveAttempted));
        var tmp_51 = align(view_44, Align_End_getInstance(), Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_58 = new (RowOrCol())(view_44.pc());
        var tmp0_elvis_lhs_58 = view_44.cbb_1;
        var p_58 = tmp0_elvis_lhs_58 == null ? view_44 : tmp0_elvis_lhs_58;
        view_44.ebb(p_58, view_58);
        view_58.xbm(false);
        view_58.zb8(get_AppDimensions().ig2_1);
        var tmp_52 = get_textButton(view_58);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_59 = new (Button())(view_58.pc());
        var tmp0_elvis_lhs_59 = view_58.cbb_1;
        var p_59 = tmp0_elvis_lhs_59 == null ? view_58 : tmp0_elvis_lhs_59;
        view_58.ebb(p_59, view_59);
        specCenteredText(view_59, 'Cancel');
        onClick(view_59, VOID, VOID, ContractorProfile$renderMainContent$slambda_10(editingContact, this));
        view_58.fbb(p_59, view_59);
        view_58.jbb(tmp_52, view_59);
        var tmp_53 = get_tertiaryButton(view_58);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_60 = new (Button())(view_58.pc());
        var tmp0_elvis_lhs_60 = view_58.cbb_1;
        var p_60 = tmp0_elvis_lhs_60 == null ? view_58 : tmp0_elvis_lhs_60;
        view_58.ebb(p_60, view_60);
        specCenteredText(view_60, 'Save');
        onClick(view_60, VOID, VOID, ContractorProfile$renderMainContent$slambda_12(this, saveAttempted, editingContact));
        view_58.fbb(p_60, view_60);
        view_58.jbb(tmp_53, view_60);
        view_44.fbb(p_58, view_58);
        view_44.jbb(tmp_51, view_58);
        view_43.fbb(p_44, view_44);
        view_39.fbb(p_43, view_43);
        view_39.jbb(tmp_34, view_43);
        view_38.fbb(p_39, view_39);
        view_1.fbb(p_38, view_38);
        view_1.jbb(tmp_31, view_38);
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        space(view, get_AppDimensions().zg1_1);
        title(view, 'Licenses');
        var licenses = remember(VOID, VOID, VOID, ContractorProfile$renderMainContent$lambda_9);
        var tmp_54 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), get_padded(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_61 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_61 = view.cbb_1;
        var p_61 = tmp0_elvis_lhs_61 == null ? view : tmp0_elvis_lhs_61;
        view.ebb(p_61, view_61);
        view_61.eba(get_AppDimensions().yg1_1);
        view_61.zb8(get_AppDimensions().yg1_1);
        view_61.jbb(view_61.ibb(get_section(view_61), get_expanding(view_61)), renderLicenses(view_61, licenses));
        view.fbb(p_61, view_61);
        view.jbb(tmp_54, view_61);
        space(view, get_AppDimensions().zg1_1);
        title(view, 'Other Documents');
        var docs = remember(VOID, VOID, VOID, ContractorProfile$renderMainContent$lambda_10);
        var tmp_55 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), get_padded(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_62 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_62 = view.cbb_1;
        var p_62 = tmp0_elvis_lhs_62 == null ? view : tmp0_elvis_lhs_62;
        view.ebb(p_62, view_62);
        view_62.eba(get_AppDimensions().yg1_1);
        view_62.zb8(get_AppDimensions().yg1_1);
        var tmp_56 = get_section(view_62);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_63 = new (Frame())(view_62.pc());
        var tmp0_elvis_lhs_63 = view_62.cbb_1;
        var p_63 = tmp0_elvis_lhs_63 == null ? view_62 : tmp0_elvis_lhs_63;
        view_62.ebb(p_63, view_63);
        view_63.eba(get_AppDimensions().xg1_1);
        renderContractorDocuments(view_63, docs);
        view_62.fbb(p_63, view_63);
        view_62.jbb(tmp_56, view_63);
        view.fbb(p_62, view_62);
        view.jbb(tmp_55, view_62);
        space(view, get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_64 = new (Space())(view.pc(), 9.0);
        var tmp0_elvis_lhs_64 = view.cbb_1;
        var p_64 = tmp0_elvis_lhs_64 == null ? view : tmp0_elvis_lhs_64;
        view.ebb(p_64, view_64);
        view.fbb(p_64, view_64);
        _this__u8e3s4.fbb(p, view);
        _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'ContractorProfile', ContractorProfile, VOID, [ContractorPage()]);
    ContractorProfileClass = $;
  }
  return ContractorProfileClass;
}
//region block: exports
export {
  ContractorProfile as ContractorProfilenrafjpe3uo0b,
};
//endregion

//# sourceMappingURL=ContractorProfile.mjs.map
